import { ref, computed, onMounted, watch } from 'vue';

export function useCarFilterResults(props, emit) {
  // Handle pagination page click
  function handlePageClick(page) {
    // Always emit fetch-results event with the selected page
    // Pass false for isLoadMore to indicate this is regular pagination, not "Load More"
    emit('fetch-results', page, false);

    // Scroll to top of results
    window.scrollTo({
      top: document.querySelector('.filter__results').offsetTop - 100,
      behavior: 'smooth'
    });
  }

  // Create computed proxy for sort prop to support v-model
  const localSort = computed({
    get() {
      return props.sort;
    },
    set(value) {
      emit('update:sort', value);
    }
  });

  // Create computed proxy for listDisplayType prop to support v-model
  const localListDisplayType = computed({
    get() {
      return props.listDisplayType;
    },
    set(value) {
      emit('update:list-display-type', value);
    }
  });

  // Tag cloud scrolling
  const tagCloud = ref(null);
  const canScrollPrev = ref(false);
  const canScrollNext = ref(false);

  function updateScrollButtons() {
    const el = tagCloud.value;
    if (!el) return;
    canScrollPrev.value = el.scrollLeft > 0;
    canScrollNext.value = el.scrollLeft + el.clientWidth < el.scrollWidth;
  }

  function onScroll() {
    updateScrollButtons();
  }

  // SEO content show more/less functionality
  const isTextTruncated = ref(true);
  const showMoreButton = ref(false);
  const seoContentRef = ref(null);

  function showFullText() {
    isTextTruncated.value = false;
  }

  function truncateText() {
    isTextTruncated.value = true;
  }

  function checkTextLength() {
    if (!props.seoDescription) return;

    // We need to wait for the DOM to be updated
    setTimeout(() => {
      const contentElement = document.querySelector('.showMoreEllipsisContent');
      if (!contentElement) return;

      // Get the text content
      const textContent = contentElement.textContent || '';

      // Check if the text is long enough to need truncation (more than 900 characters)
      showMoreButton.value = textContent.length > 900;
    }, 100);
  }

  onMounted(() => {
    if (tagCloud.value) {
      tagCloud.value.addEventListener('scroll', onScroll);
      updateScrollButtons();
    }

    // Check text length on mount
    checkTextLength();
  });

  // Watch for changes in seoDescription
  watch(() => props.seoDescription, () => {
    checkTextLength();
  });

  return {
    handlePageClick,
    localSort,
    localListDisplayType,
    tagCloud,
    canScrollPrev,
    canScrollNext,
    updateScrollButtons,
    onScroll,
    isTextTruncated,
    showMoreButton,
    seoContentRef,
    showFullText,
    truncateText,
    checkTextLength
  };
}
